// DO NOT MODIFY, this file is autogenerated by tools/build.ts
import { ɵzoneWrap } from '@angular/fire';
import {
  getAll as _getAll,
  getBoolean as _getBoolean,
  getNumber as _getNumber,
  getString as _getString,
  getValue as _getValue
} from 'rxfire/remote-config';

export const getAllChanges = ɵzoneWrap(_getAll, true);
export const getBooleanChanges = ɵzoneWrap(_getBoolean, true);
export const getNumberChanges = ɵzoneWrap(_getNumber, true);
export const getStringChanges = ɵzoneWrap(_getString, true);
export const getValueChanges = ɵzoneWrap(_getValue, true);
